import { BaseApiService, apiClient } from 'shared/api/client';

export class ListingService extends BaseApiService {
    constructor() {
        super('/crm/admin-api/listings');
    }
}

export class BannerService extends BaseApiService {
    constructor() {
        super('/crm/admin-api/banners');
    }
}

export class PostService extends BaseApiService {
    constructor() {
        super('/crm/admin-api/posts');
    }
}

export class AssortmentService extends BaseApiService {
    constructor() {
        super('/crm/admin-api/assortments');
    }
}

export const listingService = new ListingService();
export const bannerService = new BannerService();
export const postService = new PostService();
export const assortmentService = new AssortmentService();
